import { ascend, prop, sortWith } from 'ramda'

const sortByPosition = sortWith([ascend(prop('position'))])

export default sortByPosition
